import { Route, Routes } from 'react-router-dom';
import { Uebersicht } from './pages/uebersicht/Uebersicht';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { CreateTermineWrapper } from '@/domain/termine/features/CreateTermin/shared/CreateTermineWrapper';

export function Termine() {
  return (
    <Routes>
      <Route
        path="/uebersicht"
        element={
          <WithFeatureFlags name="termine">
            <Uebersicht />
          </WithFeatureFlags>
        }
      />
      <Route
        path="/uebersicht/:year/:month?/:day?"
        element={
          <WithFeatureFlags name="termine">
            <Uebersicht />
          </WithFeatureFlags>
        }>
        <Route path="create/:datum?" element={<CreateTermineWrapper />} />
      </Route>
    </Routes>
  );
}
